import { useMemo, useState } from 'react';

interface Toast {
  id: number;
  text: string;
}

export interface ToastApi {
  list: Toast[];
  push: (text: string) => void;
}

let nextId = 1;

export function useToasts(): ToastApi {
  const [list, setList] = useState<Toast[]>([]);
  // `push` must be stable so effects that depend on it don't re-run.
  const push = useMemo(
    () => (text: string) => {
      const id = nextId++;
      setList((l) => [...l.slice(-2), { id, text }]);
      window.setTimeout(() => setList((l) => l.filter((t) => t.id !== id)), 4000);
    },
    [],
  );
  return useMemo(() => ({ list, push }), [list, push]);
}

export function Toasts({ toasts }: { toasts: ToastApi }) {
  return (
    <div className="toasts" aria-live="polite">
      {toasts.list.map((t) => (
        <div key={t.id} className="toast">
          {t.text}
        </div>
      ))}
    </div>
  );
}
